import React from "react";
import Placeholder from "../ui-components/Placeholder";
import AuthenticationService from "../services/AuthenticationService";

const ListPlaceholder = () => {
  const userData = AuthenticationService.getUserData();
  return (
    <div className="flex flex-col w-full my-6 gap-4">
      <div className="flex flex-row gap-4">
        <Placeholder height="h-10" width="w-4/5" />
        <Placeholder height="h-10" width="w-1/5" />
      </div>
      <div className="flex flex-col sm:flex-row gap-4">
        <Placeholder height="h-72"  />
        <Placeholder height="h-72"  />
      </div>
      <Placeholder
        height="h-10"
        classNames={`bg-${userData.business}-400 -mb-2`}
      />
      <Placeholder height="h-80" />
    </div>
  );
};

export default ListPlaceholder;
